var map = {
	"./template.bet575": 1524,
	"./template.bet575.tsx": 1524,
	"./template.bet777": 1526,
	"./template.bet777.tsx": 1526,
	"./template.betgalaxy": 1527,
	"./template.betgalaxy.tsx": 1527,
	"./template.betprofessor": 1528,
	"./template.betprofessor.tsx": 1528,
	"./template.betroyale": 1529,
	"./template.betroyale.tsx": 1529,
	"./template.betstride": 1530,
	"./template.betstride.tsx": 1530,
	"./template.buffalobet": 1531,
	"./template.buffalobet.tsx": 1531,
	"./template.chromabet": 1532,
	"./template.chromabet.tsx": 1532,
	"./template.default": 716,
	"./template.default.tsx": 716,
	"./template.epicodds": 1533,
	"./template.epicodds.tsx": 1533,
	"./template.fiestabet": 1534,
	"./template.fiestabet.tsx": 1534,
	"./template.forsport": 1535,
	"./template.forsport.tsx": 1535,
	"./template.gigabet": 1536,
	"./template.gigabet.tsx": 1536,
	"./template.goldenbet888": 2062,
	"./template.goldenbet888.tsx": 2062,
	"./template.goldenrush": 1537,
	"./template.goldenrush.tsx": 1537,
	"./template.hyperbet": 1538,
	"./template.hyperbet.tsx": 1538,
	"./template.juicybet": 1539,
	"./template.juicybet.tsx": 1539,
	"./template.junglebet": 1540,
	"./template.junglebet.tsx": 1540,
	"./template.magnumbet": 1541,
	"./template.magnumbet.tsx": 1541,
	"./template.oldgill": 1542,
	"./template.oldgill.tsx": 1542,
	"./template.puntcity": 1543,
	"./template.puntcity.tsx": 1543,
	"./template.puntgenie": 1544,
	"./template.puntgenie.tsx": 1544,
	"./template.pyramidbet": 1545,
	"./template.pyramidbet.tsx": 1545,
	"./template.questbet": 1546,
	"./template.questbet.tsx": 1546,
	"./template.slambet": 1547,
	"./template.slambet.tsx": 1547,
	"./template.sterlingparker": 1548,
	"./template.sterlingparker.tsx": 1548,
	"./template.sugarcastle": 1549,
	"./template.sugarcastle.tsx": 1549,
	"./template.templebet": 1550,
	"./template.templebet.tsx": 1550,
	"./template.titanbet": 1551,
	"./template.titanbet.tsx": 1551,
	"./template.ts": 977,
	"./template.vikingbet": 1552,
	"./template.vikingbet.tsx": 1552,
	"./template.volcanobet": 1553,
	"./template.volcanobet.tsx": 1553,
	"./template.wellbet": 1554,
	"./template.wellbet.tsx": 1554
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2444;